import React, { useState, useEffect } from 'react';
import { Button, Upload, Form, Image, Modal } from 'antd';
import { UploadOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';

const UploadOne = (props) => {
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [fileList, setFileList] = useState(props.defaultFileList || []);

    useEffect(() => {
        setFileList(props.defaultFileList || []);
    }, [props.defaultFileList]);

    const handleChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
        
        // Convert fileList to string for parent component
        const fileArr = newFileList.map((item) => {
            if (item.response) {
                return item.response.Result;
            }
            return item.url?.split('/').pop() || item.thumbUrl?.split('/').pop();
        }).filter(Boolean);
        
        props.fileStr(fileArr.join(",") || '');
    };

    const handlePreview = async (file) => {
        let previewUrl = file.url || file.thumbUrl;
        if (file.response) {
            previewUrl = `/api/assets/images/application/${file.response.Result}`;
        }
        
        setPreviewImage(previewUrl);
        setPreviewVisible(true);
        setPreviewTitle(file.name || file.url?.substring(file.url.lastIndexOf('/') + 1));
    };

    const handleCancel = () => setPreviewVisible(false);

    const uploadButton = (
        <Button icon={<UploadOutlined />}>点击上传</Button>
    );

    return (
        <Form.Item 
            label={props.label}
            valuePropName="fileList"
            getValueFromEvent={(e) => e?.fileList || []}
            required={props.required}
        >
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                <Upload
                    name="image_file"
                    action="/api/ReactApi/zd_single_upload_image"
                    listType="picture-card"
                    onChange={handleChange}
                    onPreview={handlePreview}
                    maxCount={props.maxCount}
                    fileList={fileList}
                    itemRender={(originNode, file, fileList, actions) => (
                        <div style={{ 
                            position: 'relative', 
                            width: '100%',
                            height: '100%'
                        }}>
                            {/* Original image node */}
                            {originNode}
                            
                            {/* Hover overlay with actions */}
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: 'rgba(0,0,0,0.3)',
                                opacity: 0,
                                transition: 'all 0.3s',
                                borderRadius: 4,
                                ':hover': {
                                    opacity: 1
                                }
                            }}>
                                {/* Preview button */}
                                <EyeOutlined 
                                    style={{
                                        fontSize: '20px',
                                        color: '#fff',
                                        marginRight: 16,
                                        cursor: 'pointer'
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handlePreview(file);
                                    }}
                                />
                                
                                {/* Delete button */}
                                <DeleteOutlined 
                                    style={{
                                        fontSize: '20px',
                                        color: '#ff4d4f',
                                        cursor: 'pointer'
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        actions.remove();
                                    }}
                                />
                            </div>
                        </div>
                    )}
                >
                    {(!props.maxCount || fileList.length < props.maxCount) && uploadButton}
                </Upload>
            </div>
            
            <Modal
                open={previewVisible}
                title={previewTitle}
                footer={null}
                onCancel={handleCancel}
            >
                <Image
                    width="100%"
                    src={previewImage}
                    alt={previewTitle}
                />
            </Modal>
        </Form.Item>
    );
};

export default UploadOne;